module.exports = __webpack_public_path__ + "img/logo.1e6c3059.png";